<template>
  <div class="import_task_wrap">
    <div class="import_task_title">
      <h2>导入任务</h2>
      <div class="btn">
        <el-button @click="cancelImport">取消</el-button>
        <el-button @click="saveQuestion">保存</el-button>
      </div>
    </div>
    <div class="import_task_main">
      <div class="import_task_header">
        <el-form :model="conditionList">
          <template>
            <p class="subject_name" v-show="isOpen">科目：{{conditionList.subjectName}}</p>
          </template>
          <!-- <el-select class="search_item" v-model="conditionList.subject" @change="selectSubjectList" placeholder="请选择科目" v-show="isOpen">
            <el-option v-for="(item, i) in conditionList.subjectList" :key="i" :label="item.name" :value="item.id"></el-option>
          </el-select> -->
          <el-select class="search_item" v-model="conditionList.questionType" @change="searchFn" placeholder="请选择题型">
            <el-option v-for="(item, i) in conditionList.questionTypeList" :key="i" :label="item.questiontypeName" :value="item.id"></el-option>
          </el-select>
          <el-select class="search_item" v-model="conditionList.purpose" @change="searchFn" placeholder="请选择用途" clearable :disabled="true" v-show="false">
            <el-option v-for="(item, i) in conditionList.purposeList" :key="i" :label="item.labelName" :value="item.id"></el-option>
          </el-select>
          <el-select class="search_item" v-model="conditionList.difficulty" @change="searchFn" placeholder="请选择难度" clearable>
            <el-option v-for="(item, i) in conditionList.difficultyList" :key="i" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-select class="search_item" v-model="conditionList.company" @change="searchFn" placeholder="请选择公司" clearable>
            <el-option v-for="(item, i) in conditionList.companyList" :key="i" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-select class="search_item" v-model="conditionList.tag" @change="searchFn" placeholder="请选择标签" clearable>
            <el-option v-for="(item, i) in conditionList.tagList" :key="i" :label="item.labelName" :value="item.id"></el-option>
          </el-select>
          <el-input class="search_input" v-model="conditionList.question" @keyup.enter.native="searchFn" placeholder="请输入标题或题干" clearable></el-input>
          <template>
            <el-button @click="searchFn()">查询</el-button>
          </template>
        </el-form>
      </div>
      <div class="import_task_main_left" :style="'height:'+(windowHeight-130)+'px'" v-if="isOpen">
        <div :class="'main_tree_title '+(materialData?'':'active')" @click="selectAll">
          <!-- <img src="../../../../../static/images/course/icon-1.png" alt="" class="icon"> -->
          <img v-if="materialData" src="../../../../assets/image/sources/all.png" alt="" class="icon">
          <img v-else src="../../../../assets/image/sources/all-1.png" alt="" class="icon">
          <h3>全部</h3>
        </div>
        <div class="main_tree_content" :style="'height:'+(windowHeight-163)+'px'">
          <el-tree ref="treeData" :data="treeData"
            :props="defaultProps"
            node-key="id"
            :default-expand-all="false"
            :highlight-current="true"
            :expand-on-click-node="false"
            @node-click="handleNodeClick" >
            <p class="custom-tree-node" slot-scope="{ node }">
              <span>{{node.label}}</span>
            </p>
          </el-tree>
        </div>
      </div>
      <div v-else></div>
      <div class="import_task_main_right" :style="(isOpen?'width: calc(100% - 224px);':'width: 100%;')+'height:'+(windowHeight-130)+'px'">
        <img src="../../../../../static/images/course/close.png" alt="" v-if="isOpen" class="close" @click="isOpen = !isOpen">
        <img src="../../../../../static/images/course/open.png" alt="" v-else class="open" @click="isOpen = !isOpen">
        <div class="main_title">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" v-if="topics.length" @change="handleCheckAllChange">全选</el-checkbox>
        </div>
        <div class="testArea" ref="question_testArea" :style="'height:'+(windowHeight-230)+'px'" v-if="topics.length>0" v-loading="loading">
          <div v-for="(item,item_index) in topics" :key="item_index">
            <div class="questionInfo single_question" :class="{'questionMask': !item.isShowMore}" v-if="item.childCount === 0">
              <p>
                <el-checkbox-group v-model="checkedTopic" @change="handleCheckedTopicChange" class="single_topic_checkbox">
                  <el-checkbox :label="item.id" :key="item.id"></el-checkbox>
                </el-checkbox-group>
                <span class="num">{{ (pageTotal.currentPage-1)*10 + (item_index+1) }}、</span>
                <span class="title_info title_border">题型：{{ item.questionTypeName }}</span>
                <span class="title_info title_border">难度：{{ item.difficulty | formatDiff }}</span>
                <span class="title_info title_border">建议分数：{{ item.score }}</span>
                <span class="title_info title_border">创建人：{{ item.createName }}</span>
                <span class="title_info">创建时间：{{ item.createTime | formatTime }}</span>
              </p>
              <el-divider></el-divider>
              <p class="question_title">
                <span>{{ item.taskName }}</span>
                <el-button v-show="!item.isShowMore" @click="item.isShowMore = !item.isShowMore" type="info" size="mini">展开<i class="el-icon-caret-bottom"></i></el-button>
                <el-button v-show="item.isShowMore" @click="item.isShowMore = !item.isShowMore" type="info" size="mini">收起<i class="el-icon-caret-top"></i></el-button>
              </p>
              <div class="div_content editorShowArea ql-editor" v-html="item.questionContent"></div>
              <div class="answer">
                  <p>【知识点】
                    <template v-if="item.materials.length > 0">
                      <span v-for="(material,mat_index) in item.materials" :key="mat_index">
                        <el-tag v-if="material" :title="material.name">{{ material.name }}</el-tag>
                      </span>
                    </template>
                  </p>
                  <p>【用途】
                    <el-tag v-for="(label,label_index) in item.labels" :key="label_index" :title="label.labelName">{{ label.labelName }}</el-tag>
                  </p>
                  <p v-if="item.companyNameUp">【公司】
                    <el-tag style="vertical-align: middle;">{{ item.companyNameUp }}</el-tag>
                  </p>
                  <p v-if="item.personLabels.length > 0">【标签】
                    <el-tag v-for="(personLabel,personLabel_index) in item.personLabels" :key="personLabel_index" :title="personLabel.labelName">{{ personLabel.labelName }}</el-tag>
                  </p>
                  <p v-if="item.attachmentList.length > 0">【附件】
                    <template>
                      <span v-for="(attachment,attachment_index) in item.attachmentList" :key="attachment_index">
                        <el-tag v-if="attachment" :title="attachment.name">{{ attachment.name }}</el-tag>
                      </span>
                    </template>
                  </p>
                  <p class="lineH20">【备注】
                    <span style="margin-right:10px;">修改人：{{ item.updateName?item.updateName:'--' }}</span>
                    <span>修改时间：{{ item.updateTime?item.updateTime:'--'}}</span>
                  </p>
              </div>
            </div>
          </div>
        </div>
        <div class="no_content" :style="'height:'+(windowHeight-230)+'px'" v-else v-loading="loading">
          <img src="../../../../../static/images/wujieguo.png" alt="">
          <p>暂无内容</p>
        </div>
        <Pagination
          :currentpage="pageTotal.currentPage"
          :limit="pageTotal.pageSize"
          :total="pageTotal.total"
          layout="sizes, prev, pager, next, jumper"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
          :small="true"
        ></Pagination>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from '../../../../api/courseApi'
import Pagination from "../../../paginator/paginator";
export default {
  components: {
    Pagination
  },
  props: ['importTaskShow','subject'],
  data(){
    return{
      loading: true,
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      windowHeight: window.innerHeight,
      isOpen: true,
      conditionList: {//素材名称
        subject: null,//所选科目
        subjectName: '',
        subjectList: [],//科目列表
        questionType: null,
        questionTypeList: [],
        purpose: null,//所选用途
        purposeList: [],//用途列表
        difficulty: null,//所选难度
        difficultyList: [
          {value: "1", label: "简单"},
          {value: "2", label: "中等"},
          {value: "3", label: "困难"},
        ],//难度列表
        company: null,//所选公司
        companyList: [],//公司列表
        tag: null,//所选标签
        tagList: [],//标签列表
        question: ""
      },
      topics: [],//题目列表
      materialData:null,
      checkAll: false,
      checkedTopic: [],
      isIndeterminate: false,
      isloading: '',
      list: [],
      pageTotal: {//分页
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      stationDatas: [],
      show: null,
      productFlag: sessionStorage.getItem('productFlag')
    }
  },
  mounted(){
    this.getQuestionType(this.subject)//获取题型
    this.getQuestionPurpose()//获取用途
    this.queryCompany()//获取公司
    this.getMaterial()//获取科目树
  },
  filters: {
    formatTime(time) {
      return (time = time.slice(0, 10) + " " + time.slice(11, 19));
    },
    formatDiff(num) {
      if (num === 1) {
        return "简单";
      } else if (num === 2) {
        return "中等";
      } else if (num === 3) {
        return "困难";
      }
    }
  },
  methods:{
    getQuestionType(id){//获取试题类型
      let that = this
      api.getQuestionType(id).then(rs=>{
        if(rs.code==0){
          that.conditionList.questionTypeList = []
          rs.data.forEach(v=>{
            if(v.internaltypeid==9){
              let obj = {
                childinternaltypeId: v.childinternaltypeId,
                id: v.id,
                internaltypeid: v.internaltypeid,
                questiontypeName: v.questiontypeName,
                questiontypeRemark: v.questiontypeRemark,
                status: v.status,
                subjectId: v.subjectId,
              }
              that.conditionList.questionTypeList.push(obj)
              that.conditionList.questionType =  that.conditionList.questionTypeList[0].id
            }
          })
        }else{
          that.$messageError(rs.msg)
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    getQuestionPurpose(){//获取用途和标签
      let that = this
      api.getQuestionPurpose().then(rs=>{
        if(rs.code==0){
          that.conditionList.purposeList = rs.data
          if(that.productFlag==1){ that.conditionList.purpose = 6 }
          if(that.productFlag==2){ that.conditionList.purpose = 2 }
          if(that.productFlag==3){ that.conditionList.purpose = 3 }
          if(that.productFlag==4){ that.conditionList.purpose = 4 }
        }else{
          that.$messageError(rs.msg)
        }
      }).catch(err=>{
        console.log(err)
      })
      api.getQuestionPurpose({lableType: 1}).then(rs=>{
        if(rs.code==0){
          that.conditionList.tagList = rs.data
        }else{
          that.$messageError(rs.msg)
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    queryCompany(){//获取公司
      let that = this
      let obj = {
        subjectId: this.subject
      }
      api.queryCompany(obj).then(rs=>{
        if(rs.code==0){
          if(rs.data.length>0){
            let arr = []
            rs.data.forEach(v=>{
              if(v.lableIds.includes(4)){
                arr.push(v)
              }
            })
            that.conditionList.companyList = arr
          }else{
            that.conditionList.companyList = []
          }

        }else{
          that.$messageError(rs.msg)
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    getMaterial(){//获取科目树
      let that = this;
      api.getMaterial().then((rs)=>{
        if(rs.code == 0){
          if(rs.data.length>0){
            that.conditionList.subjectList = rs.data;
            that.conditionList.subject = this.$route.query.subjectName.subjectId;
            that.conditionList.subjectName = this.$route.query.subjectName;
            that.treeData = that.conditionList.subjectList[0].materials
            that.selectAll()
            // that.$nextTick(()=>{
            //   that.handleNodeClick(that.treeData[0]);
            //   that.$refs.treeData.setCurrentKey(that.treeData[0].id);
            // })
          }else{
            that.conditionList.subjectList = [];
          }
        }else{
          this.$messageError(rs.msg)
        }
      }).catch((error)=>{
        console.log(error)
      })
    },
    selectSubjectList(){//获取科目树
      let that = this
      that.conditionList.subjectList.forEach(v=>{
        if(that.conditionList.subject == v.id){
          that.treeData = v.materials
        }
      })
      that.$nextTick(()=>{
        that.handleNodeClick(that.treeData[0]);
        that.$refs.treeData.setCurrentKey(that.treeData[0].id);
      })
    },
    handleNodeClick(data) {//点击目录
      let that = this;
      this.materialData = data;
      this.pageTotal.currentPage = 1
      this.getQuestion()
    },
    searchFn(){
      this.getQuestion()
    },
    selectAll(){
      this.$refs.treeData.setCurrentKey();
      this.materialData = null;
      this.pageTotal.currentPage = 1
      this.getQuestion()
    },
    handleCheckAllChange(val) {//选择题目--全选
      if(val){
        this.checkedTopic = []
        this.topics.forEach(item=>{
          this.checkedTopic.push(item.id);
        })
      }else{
        this.checkAll = false;
        this.checkedTopic = [];
      }
      this.isIndeterminate = false;
    },
    handleCheckedTopicChange(value) {//选择题目--单选
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.topics.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.topics.length;
    },
    showToggleBtn(item){
      if(item.showToggle){
        item.showToggle=false
        item.topicHeight='auto'
      }else{
        item.showToggle=true
        item.topicHeight='180px'
      }
    },
    queryQuestionList(){//获取科目树
      let that = this
      let obj = {
        beginTime: null,
        companyId: null,
        difficulty: null,
        endTime: null,
        labelId: "",
        materialIds: [],
        pageNo: 1,
        pageSize: 10,
        personLabels: null,
        questionContent: null,
        questionTypeId: "",
        subjectId: this.subject,
      }
    },
    getQuestion(){
      this.loading = true
      let that = this
      this.checkAll = false;
      this.checkedTopic = [];
      this.isIndeterminate = false;
      this.topics = [];
      let tagArr = null
      if(this.conditionList.tag){
        let tagObj = {
          id: this.conditionList.tag
        }
        tagArr = [tagObj]
      }else{
        tagArr = null
      }
      let obj = {
        beginTime: null,//开始时间
        endTime: null,//结束时间
        companyId: this.conditionList.company,//公司id
        difficulty: this.conditionList.difficulty,//难度
        // labelId: this.conditionList.purpose,//用途
        labelId: 4,//用途
        materialIds: this.materialData?[this.materialData.id]:null,//目录id集合
        pageNo: this.pageTotal.currentPage,//当前页
        pageSize: this.pageTotal.pageSize,//每页个数
        personLabels: tagArr,//标签
        questionContent: this.conditionList.question,//试题内容
        questionTypeId: this.conditionList.questionType,//题型id
        subjectId: this.subject//科目id
      };
      api.queryQuestionList(obj).then(res=>{
        if(res.code==0){
          that.topics = res.data.list;
          that.pageTotal.total = res.data.totalCount
          that.loading = false
          if (that.topics.length === 0) return
            that.topics.forEach(item=>{
              that.$set(item, "isShowMore", false)
              if (item.childQuestions.length != 0) {
                  item.childQuestions.forEach(val=>{
                    that.$set(val, "isShowMore", false)
                    // 处理事项中的公司&岗位
                    if (val.questionEvent != null && val.questionEvent.dynmaicParamList.length>0) {
                      that.conditionList.companyList.forEach(companyItem=>{
                        if (companyItem.templateCode == val.questionEvent.dynmaicParamList[1].value) {
                          that.$set(val, 'companyName', companyItem.name)
                        }
                      })
                      this.stationDatas.forEach(stationItem=>{
                        if (stationItem.code == val.questionEvent.dynmaicParamList[2].value) {
                          that.$set(val, 'stationName', stationItem.name)
                        }
                      })
                    }
                    // 处理公司
                    if ( val.companyId != null ) {
                      that.conditionList.companyList.forEach(companyUpItem=>{
                        if (companyUpItem.id === val.companyId) {
                          that.$set(val, 'companyNameUp', companyUpItem.name)
                        }
                      })
                    }
                  })
              }
              // 处理事项中的公司&岗位
              if (item.questionEvent != null && item.questionEvent.dynmaicParamList.length>0) {
                that.conditionList.companyList.forEach(companyItem=>{
                  if (companyItem.templateCode == item.questionEvent.dynmaicParamList[1].value) {
                    that.$set(item, 'companyName', companyItem.name)
                  }
                })
                this.stationDatas.forEach(stationItem=>{
                  if (stationItem.code == item.questionEvent.dynmaicParamList[2].value) {
                    that.$set(item, 'stationName', stationItem.name)
                  }
                })
              }
              // 处理公司
              if ( item.companyId != null ) {
                that.conditionList.companyList.forEach(companyUpItem=>{
                  if (companyUpItem.id === item.companyId) {
                    that.$set(item, 'companyNameUp', companyUpItem.name)
                  }
                })
              }
            })
            that.$nextTick(()=>{
              if (sessionStorage.getItem("testCenterSearchParams") != null && this.isHasScrollTop == true) {
                this.$refs.question_testArea.scrollTop = JSON.parse(sessionStorage.getItem("testCenterSearchParams")).scrollTop;
              } else {
                this.$refs.question_testArea.scrollTop = 0;
              }
            })
        }else{
          this.$messageError(res.msg)
        }
      }).catch((error)=>{
        console.log(error)
      })
    },
    handleCurrentChange(val) {
      this.pageTotal.currentPage = val;
      this.$refs.question_testArea.scrollTop = 0;
      this.getQuestion()
    },
    handleSizeChange(val){
      this.pageTotal.pageSize = val;
      this.pageTotal.currentPage = 1;
      this.$refs.question_testArea.scrollTop = 0;
      this.getQuestion()
    },
    saveQuestion(){
      if(this.checkedTopic.length){
        let newArr = [];
        this.checkedTopic.forEach(item=>{
          let obj = {};
          obj.catalogId = 0;
          obj.courseId = this.$route.query.id;
          obj.resourceId = item;
          obj.type = 3;
          newArr.push(obj);
        })
        let param = {
          catalogId: 0,
          courseId:  this.$route.query.id,
          list: newArr
        }
        this.$emit('importTaskSave',param);
        // api.submitMaterialBtn(param).then(res=>{
        //   if(res.code == '0'){
        //     this.$store.state.questionList = res.data;
        //     this.$emit('importTaskSave');
        //   }else{
        //     this.$messageError(res.msg)
        //   }
        // }).catch(error=>{
        //   console.log(error);
        // })
      }else{
        this.$messageWarning('请选择要添加的试题');
        return
      }
    },
    cancelImport(){
      this.$emit('cancelImport')
    },
    emptyData(){
      this.checkAll = false
      this.checkedTopic = []
      this.conditionList.company = null
      this.conditionList.difficulty = null
      this.conditionList.purpose = null
      this.conditionList.tag = null
      this.conditionList.question = ''
      this.pageTotal.currentPage = 1
      // materialIds: [this.materialData.id],//目录id集合
    }
  },
  watch:{
    'importTaskShow':function(val){
      if(val){
        this.getQuestionType(this.subject)//获取题型
        this.getQuestionPurpose()//获取用途
        this.queryCompany()//获取公司
        this.getMaterial()//获取科目树
        this.getQuestion()
      }else{
        this.emptyData()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .import_task_wrap{
    .import_task_title{
      height: 64px;
      border-bottom: 1px solid #DDE0E2;
      position: relative;
      h2{
        font-size:16px;
        font-weight:bold;
        color:rgba(13,13,13,1);
        position: relative;
        line-height: 64px;
        padding-left: 28px;
        &::after{
          content:'';
          position: absolute;
          left: 16px;
          top: 25px;
          background: #5397F7;
          width: 4px;
          height: 12px;
        }
      }
      .btn{
        position: absolute;
        right: 20px;
        top: 17px;
        button{
          width:72px;
          height:28px;
          background:rgba(83,151,247,1);
          border-radius:4px;
          color: #fff;
          padding: 0;
          font-size: 12px;
          &:hover{
            opacity: 0.8;
          }
          &:last-child{
            margin-left: 12px;
          }
        }
      }
    }
    .import_task_main{
      padding: 16px 0 16px 16px;
      box-sizing: border-box;
      .import_task_header{
        height: 48px;
        /deep/ .el-form{
          display: flex;
          .subject_name{
            width: 224px;
            font-size: 14px;
            font-weight: 600;
            line-height: 28px;
            color: #0D141E;
          }
          .el-select{
            width: 120px;
            margin-right: 8px;
            .el-input__inner{
              height: 28px;
              line-height: 28px;
              background: #F1F2F4;
            }
            .el-input__icon{
              line-height: 28px;
            }
            &:first-child{
              width: 220px;
              margin-right: 4px;
            }
          }
          .search_input{
            width: 140px;
            margin-right: 10px;
            .el-input__inner{
              height: 28px;
              line-height: 28px;
              background: #F1F2F4;
              padding: 0 10px;
            }
          }
          button{
            width:72px;
            height:28px;
            background:rgba(83,151,247,1);
            border-radius:4px;
            padding: 0;
            color: #fff;
            border: none;
            &:hover{
              opacity: 0.8;
            }
          }
          /deep/ .el-input__suffix{
            line-height: 28px;
          }
          /deep/ .el-input__icon{
            line-height: 28px;
          }
        }
      }
      .import_task_main_left{
        float: left;
        width: 219px;
        border: 1px solid #F4F7FD;
        border-right-width: 4px;
        .main_tree_title{
          width: 100%;
          height: 32px;
          // background:rgba(83,151,247,1);
          border-radius:2px;
          display: flex;
          align-items: center;
          cursor: pointer;
          img{
            height: 14px;
            width: 14px;
            margin-left: 12px;
            margin-right: 10px;
          }
          h3{
            font-size:14px;
            color: #666;
          }
          &:hover{
            background: #EDF4FF;
          }
        }
        .active{
          background-color: #EDF4FF;
          border-left: 2px solid #5397F7;
        }
        /deep/ .main_tree_content{
          background: #fff;
          overflow-y:auto;
          .el-tree-node__content{
            height: 32px;
            position: relative;
            .el-tree-node__expand-icon{
              color: #5397F7;
            }
            .el-tree-node__expand-icon.is-leaf{
              color: transparent !important;
              cursor: default;
            }
            .custom-tree-node{
              font-size:12px;
              font-weight:400;
              color: #333333;
              width: calc(100% - 35px);
            }
          }
          .el-tree-node>.el-tree-node__children{
            overflow:inherit;
          }
          .el-tree-node.is-current > .el-tree-node__content {
            background-color: #EDF4FF;
            border-left: 2px solid #5397F7;
          }
          .el-tree-node__content:hover{
            background: #EDF4FF;
          }
        }
      }
      .import_task_main_right{
        float: right;
        position: relative;
        padding: 0 0 0 21px;
        box-sizing: border-box;
        overflow-y: auto;
        .open,.close{
          position: absolute;
          width: 16px;
          top: 0;
          left: 0;
          bottom: 0;
          margin: auto;
          cursor: pointer;
        }
        .main_title{
          height: 40px;
        }
        p { margin: 0px; }
        .testArea {
          width: 100%;
          overflow-y: auto;
          border-radius: 3px;
          padding: 0 21px 0 0;
          box-sizing: border-box;
          .questionMask {
            height: 120px;
            overflow: hidden;
            position: relative;
          }
          .questionInfo {
            padding: 10px;
            background-color: #F4F7FE;
            border-radius: 3px;
            margin-bottom: 10px;
            position: relative;
            font-size: 12px;
            &:hover {
              box-shadow: 0px 0px 5px #CCCCCC;
            }
            /deep/ .single_topic_checkbox{
              display: inline-block;
              .el-checkbox__label{
                display: none;
              }
            }
            .num {
              font-size: 12px;
              font-weight: bolder;
            }
            .title_info {
              color: #9498A3;
            }
            .title_border {
                &::after {
                    content: "";
                    display: inline-block;
                    width: 2px;
                    height: 14px;
                    background-color: #9498A3;
                    margin: 0px 10px;
                    vertical-align: middle;
                    margin-top: -3px;
                }
            }
            .question_title {
              margin-bottom: 5px;
              color: #0D0D0D;
              button {
                float: right;
                background-color: #B4BBCD;
                border: #B4BBCD;
                &:hover {
                  background-color: #a2a4ab;
                }
              }
            }
            .div_content {
              clear: both;
              width: 99%;
              text-align: justify;
              margin-bottom: 10px;
              /deep/ img {
                max-width: 90%;
                display: block;
              }
              /deep/ p {
                word-break: break-word;
              }
            }
            .answer {
              color: #9498A3;
              font-size: 12px;
              p {
                line-height: 32px;
                word-break: break-word;
                .el-tag{
                  height: 24px;
                  line-height: 24px;
                  background: rgba($color: #D5DAED, $alpha: 0.3);
                  color: #9498A3;
                  border: none;
                  padding: 0 10px;
                  margin-right: 5px;
                  max-width: 100px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  vertical-align: middle;
                  font-size: 12px;
                }
              }
            }
          }
        }
        .no_content{
          width: 100%;
          overflow-y: auto;
          border-radius: 3px;
          text-align: center;
          img{
            margin-top: 10%;
            width: 100px;
          }
          p{
            font-size: 14px;
            margin-top: 10px;
          }
        }
        /deep/ .el-divider {
          margin: 10px 0px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/course/components/importTask.vue